import Tippy from "@tippyjs/react";
import { FC } from "react";
import styled from "styled-components";
import "tippy.js/dist/tippy.css";

import { CHART_COLORS, formatEuro } from "../common/constants";
import { TopSpenderData } from "../common/types";

const StyledTopSpenders = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const StyledSpender = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem;
  background: #f9f9f9;
  border-radius: 4px;
  border-left: 4px solid ${CHART_COLORS.uniqueBuyers};
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #f1f1f1;
  }
`;

const SpenderInfo = styled.div`
  font-weight: bold;
`;

const SpenderStats = styled.div`
  text-align: right;
`;

type TopSpendersProps = {
  data: TopSpenderData[];
};

export const TopSpenders: FC<TopSpendersProps> = ({ data }) => {
  return (
    <StyledTopSpenders>
      {data.map((spender, index) => (
        <Tippy
          key={spender.userId}
          content={
            <div
              style={{
                padding: "5px",
                backgroundColor: "black",
                color: "white",
                borderRadius: "4px",
                textAlign: "left",
                maxWidth: "400px",
              }}
            >
              <strong>Détail des achats de {spender.username}:</strong>
              <ul
                style={{
                  paddingLeft: "20px",
                  margin: "5px 0 0 0",
                  listStyle: "disc",
                }}
              >
                {spender.purchases
                  .sort((a, b) => b.date.getTime() - a.date.getTime())
                  .map((p, i) => (
                    <li key={i}>
                      {p.itemName} ({p.price} teeth) -{" "}
                      {p.date.toLocaleDateString("fr-FR")}
                    </li>
                  ))}
              </ul>
            </div>
          }
        >
          <StyledSpender>
            <SpenderInfo>
              #{index + 1} {spender.username}
            </SpenderInfo>
            <SpenderStats>
              <div>
                {formatEuro(spender.totalSpentEuro)} ({spender.totalSpent}{" "}
                teeth)
              </div>
              <div style={{ fontSize: "0.8rem", color: "#666" }}>
                {spender.purchaseCount} achats
              </div>
            </SpenderStats>
          </StyledSpender>
        </Tippy>
      ))}
    </StyledTopSpenders>
  );
};
